const CLIENT_CONFIG = {
    WEBWORK_STANDARD: {
      BASE_NAME: "/WEBWORK_STANDARD",
      STORAGE_PREFIX: "WEBWORK_STANDARD",
      PUBLIC_URL: "WEBWORK_STANDARD",
      endpoints: {
        getUserInfo: (site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber) => `/STANDARD_get_user_information.php?site_cd=${encodeURIComponent(site_cd)}&login_id=${encodeURIComponent(login_id)}&mst_rowID=${encodeURIComponent(mst_rowID)}&isCreatingWorkReq=${encodeURIComponent(isCreatingWorkReq)}&workRequestNumber=${encodeURIComponent(workRequestNumber)}`,
        getWorkAreaDropdown: (site_cd) => `/STANDARD_get_work_area_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getPriorityDropdown: (site_cd) => `/STANDARD_get_priority_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getLevelDropdown: (site_cd, wrk_Ara) =>`/STANDARD_get_level_dropdown.php?site_cd=${encodeURIComponent(site_cd)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}`,
        getWorkGroupDropdown: (site_cd) => `/STANDARD_get_work_group_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getAssetNumberDropdown: (site_cd, ast_lvl, wrk_Ara, asset_locn) =>`/STANDARD_get_asset_number_dropdown.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}&asset_locn=${encodeURIComponent(asset_locn)}`,
        getAssetLocationDropdown: (site_cd, ast_lvl, wrk_Ara) =>`/STANDARD_get_asset_location_dropdown.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}`,
        getFaultCodeDropdown: (site_cd) => `/STANDARD_get_fault_code_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getAssetNumberUsingScanQR: (site_cd, asset_no) =>`/STANDARD_get_asset_number_using_scan_QR.php?site_cd=${encodeURIComponent(site_cd)}&asset_no=${encodeURIComponent(asset_no)}`,
        createWorkRequest: () => `/STANDARD_create_work_request.php`,
      },
    },

    SMCD_CUSTOMIZATION: {
      BASE_NAME: "/SMCD_CUSTOMIZATION",
      STORAGE_PREFIX: "SMCD_CUSTOMIZATION",
      PUBLIC_URL: "SMCD_CUSTOMIZATION",
      API_SCRIPT_PREFIX: "SMCD",
      endpoints: {

        // General
        getUserInfo: (site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber) => `/SMCD_get_user_information.php?site_cd=${encodeURIComponent(site_cd)}&login_id=${encodeURIComponent(login_id)}&mst_rowID=${encodeURIComponent(mst_rowID)}&isCreatingWorkReq=${encodeURIComponent(isCreatingWorkReq)}&workRequestNumber=${encodeURIComponent(workRequestNumber)}`,
        
        // ==================== REQUEST BY DEPARTMENT ====================
        
        // Department Dropdown
        getDepartmentDropdownByDepartment: (site_cd, services) => `/SMCD_get_department_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,
        
        // Level Dropdown
        getLevelDropdownByDepartment: (site_cd, department, services) =>`/SMCD_get_level_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&wkr_mst_location=${encodeURIComponent(department)}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,

        // Services Dropdown
        getServicesDropdownByDepartment: (site_cd) => `/SMCD_get_services_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}`,
        
        // Asset Number Dropdown
        getAssetNumberDropdownByDepartment: (site_cd, ast_area, ast_locn, ast_group) =>`/SMCD_get_asset_number_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&ast_area=${encodeURIComponent(ast_area)}&ast_locn=${encodeURIComponent(ast_locn)}&ast_group=${encodeURIComponent(ast_group)}`,
        
        // Fault Code Dropdown
        getFaultCodeDropdownByDepartment: (site_cd, services) => `/SMCD_get_fault_code_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&wkr_mst_services=${encodeURIComponent(services)}`,

        // Request Classification Dropdown
        getRequestClassificationDropdownByDepartment: (site_cd, gs_foreman) => `/SMCD_get_request_classification_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&gs_foreman=${encodeURIComponent(gs_foreman)}`,

        // Asset Location Dropdown
        getAssetLocationDropdownByDepartment: (site_cd, ast_lvl, wrk_Ara) =>`/SMCD_get_asset_location_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}`,
        
        // USED IN THE FUTURE
        // getPriorityDropdownByDepartment: (site_cd) => `/SMCD_get_priority_dropdown_by_department.php?site_cd=${site_cd}`,

        // Asset Number Using Scan QR (Not being handle yet)
        // getAssetNumberUsingScanQRByDepartment: (site_cd, asset_no) =>`/SMCD_get_asset_number_using_scan_QR_by_department.php?site_cd=${encodeURIComponent(site_cd)}&asset_no=${encodeURIComponent(asset_no)}`,
        
        // Create Work Request
        createWorkRequestByDepartment: () => `/SMCD_create_work_request_by_department.php`,

        // ==================== REQUEST BY LOCATION ====================

        // Services Dropdown
        getServicesDropdownByLocation: (site_cd) => `/SMCD_get_services_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}`,

        // Level Dropdown
        getLevelDropdownByLocation: (site_cd, services) =>`/SMCD_get_level_dropdown_by_location.php/?site_cd=${encodeURIComponent(site_cd)}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,
        
        // Room / Sub Area Dropdown
        getRoomSubAreaDropdownByLocation: (site_cd, level, services) => `/SMCD_get_room_sub_area_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}${level ? `&level=${encodeURIComponent(level)}` : ''}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,

        // Asset Number Dropdown
        getAssetNumberDropdownByLocation: (site_cd, ast_lvl, wrk_Ara, asset_locn) =>`/SMCD_get_asset_number_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}&asset_locn=${encodeURIComponent(asset_locn)}`,

        // Fault Code Dropdown
        getFaultCodeDropdownByLocation: (site_cd, services) => `/SMCD_get_fault_code_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}&wkr_mst_services=${encodeURIComponent(services)}`,
        
        // Request Classification Dropdown
        getRequestClassificationDropdownByLocation: (site_cd, gs_foreman) => `/SMCD_get_request_classification_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}&gs_foreman=${encodeURIComponent(gs_foreman)}`,

        // USED IN THE FUTURE
        // getPriorityDropdownByLocation: (site_cd) => `/SMCD_get_priority_dropdown_by_location.php/?site_cd=${site_cd}`,

        // Asset Number Using Scan QR (Not being handle yet)
        // getAssetNumberUsingScanQRByLocation: (site_cd, asset_no) =>`/SMCD_get_asset_number_using_scan_QR_by_location.php?site_cd=${site_cd}&asset_no=${asset_no}`,
        
        // Create Work Request
        createWorkRequestByLocation: () => `/SMCD_create_work_request_by_location.php`,  
      },
    },

    SMCI_CUSTOMIZATION: {
      BASE_NAME: "/SMCI_CUSTOMIZATION",
      STORAGE_PREFIX: "SMCI_CUSTOMIZATION",
      PUBLIC_URL: "SMCI_CUSTOMIZATION",
      API_SCRIPT_PREFIX: "SMCI",
      endpoints: {

        // General
        getUserInfo: (site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber) => `/SMCI_get_user_information.php?site_cd=${encodeURIComponent(site_cd)}&login_id=${encodeURIComponent(login_id)}&mst_rowID=${encodeURIComponent(mst_rowID)}&isCreatingWorkReq=${encodeURIComponent(isCreatingWorkReq)}&workRequestNumber=${encodeURIComponent(workRequestNumber)}`,
        
        // ==================== REQUEST BY DEPARTMENT ====================
        
        // Department Dropdown
        getDepartmentDropdownByDepartment: (site_cd, services) => `/SMCI_get_department_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,
        
        // Level Dropdown
        getLevelDropdownByDepartment: (site_cd, department, services) =>`/SMCI_get_level_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&wkr_mst_location=${encodeURIComponent(department)}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,

        // Services Dropdown
        getServicesDropdownByDepartment: (site_cd) => `/SMCI_get_services_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}`,
        
        // Asset Number Dropdown
        getAssetNumberDropdownByDepartment: (site_cd, ast_area, ast_locn, ast_group) =>`/SMCI_get_asset_number_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&ast_area=${encodeURIComponent(ast_area)}&ast_locn=${encodeURIComponent(ast_locn)}&ast_group=${encodeURIComponent(ast_group)}`,
        
        // Fault Code Dropdown
        getFaultCodeDropdownByDepartment: (site_cd, services) => `/SMCI_get_fault_code_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&wkr_mst_services=${encodeURIComponent(services)}`,

        // Request Classification Dropdown
        getRequestClassificationDropdownByDepartment: (site_cd, gs_foreman) => `/SMCI_get_request_classification_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&gs_foreman=${encodeURIComponent(gs_foreman)}`,

        // Asset Location Dropdown
        getAssetLocationDropdownByDepartment: (site_cd, ast_lvl, wrk_Ara) =>`/SMCI_get_asset_location_dropdown_by_department.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}`,
        
        // Create Work Request
        createWorkRequestByDepartment: () => `/SMCI_create_work_request_by_department.php`,

        // ==================== REQUEST BY LOCATION ====================

        // Services Dropdown
        getServicesDropdownByLocation: (site_cd) => `/SMCI_get_services_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}`,

        // Level Dropdown
        getLevelDropdownByLocation: (site_cd, services) =>`/SMCI_get_level_dropdown_by_location.php/?site_cd=${encodeURIComponent(site_cd)}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,
        
        // Room / Sub Area Dropdown
        getRoomSubAreaDropdownByLocation: (site_cd, level, services) => `/SMCI_get_room_sub_area_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}${level ? `&level=${encodeURIComponent(level)}` : ''}${services ? `&wkr_mst_services=${encodeURIComponent(services)}` : ''}`,

        // Asset Number Dropdown
        getAssetNumberDropdownByLocation: (site_cd, ast_lvl, wrk_Ara, asset_locn) =>`/SMCI_get_asset_number_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}&asset_locn=${encodeURIComponent(asset_locn)}`,

        // Fault Code Dropdown
        getFaultCodeDropdownByLocation: (site_cd, services) => `/SMCI_get_fault_code_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}&wkr_mst_services=${encodeURIComponent(services)}`,
        
        // Request Classification Dropdown
        getRequestClassificationDropdownByLocation: (site_cd, gs_foreman) => `/SMCI_get_request_classification_dropdown_by_location.php?site_cd=${encodeURIComponent(site_cd)}&gs_foreman=${encodeURIComponent(gs_foreman)}`,
        
        // Create Work Request
        createWorkRequestByLocation: () => `/SMCI_create_work_request_by_location.php`,  
      },
    },

    // ==================== VERMI CUSTOMIZATION ====================
    VERMI_CUSTOMIZATION: {
      BASE_NAME: "/VERMI_CUSTOMIZATION",
      STORAGE_PREFIX: "VERMI_CUSTOMIZATION",
      PUBLIC_URL: "VERMI_CUSTOMIZATION",
      endpoints: {
        getUserInfo: (site_cd, login_id, mst_rowID, isCreatingWorkReq, workRequestNumber) => `/VERMI_get_user_information.php?site_cd=${encodeURIComponent(site_cd)}&login_id=${encodeURIComponent(login_id)}&mst_rowID=${encodeURIComponent(mst_rowID)}&isCreatingWorkReq=${encodeURIComponent(isCreatingWorkReq)}&workRequestNumber=${encodeURIComponent(workRequestNumber)}`,
        getWorkAreaDropdown: (site_cd) => `/VERMI_get_work_area_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getPriorityDropdown: (site_cd) => `/VERMI_get_priority_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getLevelDropdown: (site_cd, wrk_Ara) =>`/VERMI_get_level_dropdown.php?site_cd=${encodeURIComponent(site_cd)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}`,
        getWorkGroupDropdown: (site_cd) => `/VERMI_get_work_group_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getAssetNumberDropdown: (site_cd, ast_lvl, wrk_Ara, asset_locn) =>`/VERMI_get_asset_number_dropdown.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}&asset_locn=${encodeURIComponent(asset_locn)}`,
        getAssetLocationDropdown: (site_cd, ast_lvl, wrk_Ara) =>`/VERMI_get_asset_location_dropdown.php?site_cd=${encodeURIComponent(site_cd)}&ast_lvl=${encodeURIComponent(ast_lvl)}&wrk_Ara=${encodeURIComponent(wrk_Ara)}`,
        getFaultCodeDropdown: (site_cd) => `/VERMI_get_fault_code_dropdown.php?site_cd=${encodeURIComponent(site_cd)}`,
        getAssetNumberUsingScanQR: (site_cd, asset_no) =>`/VERMI_get_asset_number_using_scan_QR.php?site_cd=${encodeURIComponent(site_cd)}&asset_no=${encodeURIComponent(asset_no)}`,
        createWorkRequest: () => `/VERMI_create_work_request.php`,
      },
    },
  };
  
  export default CLIENT_CONFIG;
  